import React, { useRef, useState } from "react";
import MspAccountsHeader from "../SubscriptionBackendPortal/mspAccountsSubscription/msp-accounts-page-header/MspAccountsHeader";
import useFilters from "../../hooks/filters.hook";
import useDateFormat from "../../hooks/use-date-format.hook";
import { DistributorsTable } from "./distributors-table/distributors-table";
import { AddDistributorModal } from "./add-distributor-modal/add-distributor-modal";

const Distributors = () => {
  const searchInputRef = useRef();
  const [searchString, setSearchString] = useState("");
  const [searchInput, setSearchInput] = useState(false);
  const [headersList, setHeadersList] = useState([]);
  const [listDataLoading, setListDataLoading] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [pendingDistributors, setPendingDistributors] = useState([]);
  const dateFormat = useDateFormat();
  const { selectedFilters, setSelectedFilters, addFilter } = useFilters({
    onFiltersUpdate: (filters) => {
      console.log("Filters updated:", filters);
    }
  });
  
  const handleInputChange = (e) => {
    setSearchString(e.target.value);
  };

  const getPageData = (params) => {
    console.log("getPageData called with:", params);
  };

  const sortData = {
    sortItem: null
  };

  const sortRecords = (sortItem) => {
    console.log("sortRecords called with:", sortItem);
  };

  const onInviteClick = () => {
    setShowAddModal(true);
  };

  const onBulkAction = (action) => {
    console.log("Bulk action:", action);
  };

  const onSelectRows = () => {
    console.log("Select rows clicked");
  };

  const handleAddDistributor = (formData) => {
    const newPendingDistributor = {
      id: `pending-${Date.now()}`,
      company: {
        name: formData.companyName,
        initial: formData.companyName?.charAt(0).toUpperCase() || "",
        bgColor: "violet",
      },
      country: formData.country || "",
      contact: {
        name: formData.principalContact,
        email: formData.accountEmail,
        initial: formData.principalContact?.charAt(0).toUpperCase() || "",
        bgColor: "violet",
      },
      status: "Pending",
    };
    
    setPendingDistributors((prev) => [newPendingDistributor, ...prev]);
    setShowAddModal(false);
  };

  const tableFilters = [];

  return (
    <div style={{ padding: "24px 40px" }}>
      <MspAccountsHeader
        variant="v2"
        totalClients={0}
        listDataLoading={listDataLoading}
        searchString={searchString}
        searchInputRef={searchInputRef}
        handleInputChange={handleInputChange}
        setSearchInput={setSearchInput}
        tableFilters={tableFilters}
        addFilter={addFilter}
        headersList={headersList}
        setHeadersList={setHeadersList}
        getPageData={getPageData}
        sortData={sortData}
        sortRecords={sortRecords}
        onInviteClick={onInviteClick}
        selectedFilters={selectedFilters}
        setSelectedFilters={setSelectedFilters}
        dateFormat={dateFormat}
        isArchived={false}
        selectedRows={[]}
        onBulkAction={onBulkAction}
        onSelectRows={onSelectRows}
        forceShowCheckboxes={false}
        isDistributorView={true}
      />

      <DistributorsTable pendingDistributors={pendingDistributors} />

      <AddDistributorModal 
        show={showAddModal}
        onHide={() => setShowAddModal(false)}
        onContinue={handleAddDistributor}
      />
    </div>
  );
};

export default Distributors;
